module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Conformité générale","text":"Le suivi des tâches en cours est essentiel pour garantir la conformité et améliorer les performances.","link":"Consulter les tâches à faire"},"en":{"title":"General compliance","text":"Tracking ongoing tasks is essential to ensure compliance and improve performance.","link":"View tasks to do"}}')
  delete Component.options._Ctor
}
